import * as Yup from 'yup';

export const receiptSchema = Yup.object({
  from: Yup.string().label('From').required('Required'),
  title: Yup.string().label('Title').required('Required'),
  message: Yup.string().label('Message').required('Required'),
  inv: Yup.string().label('Invoice Number').required('Required'),
  currency: Yup.string().label('Currency').required('Required')
});
